import { areaBand, DriverName, JobQuantities, quantitiesFit } from "@gigsync/protocol";
import { detailsToDrivers } from "../estimate/driver-details.js";
import { arrangementIn } from "../estimate/scope.js";
/**
 * A signed job's quantities for its record (ADR 0041 §4): the price drivers both phones hold alike in the request's
 * details, as counts and fixed choices, the floor area as a band. Drivers the scope already keeps (meals, who buys the
 * paint, how often, the problem) are left to it. Never words: the strict schema refuses anything else.
 */
const D = DriverName.enum;
/** Drivers a record keeps in its scope columns instead. */
const IN_SCOPE = [D.meals, D.paint_by, D.frequency, D.problem];
export function jobQuantities(trade, details) {
    const drivers = detailsToDrivers(trade, details);
    const { area_sqft, ...rest } = drivers;
    const kept = Object.fromEntries(Object.entries(rest).filter(([name]) => !IN_SCOPE.includes(name)));
    const arrangement = arrangementIn(trade, details);
    const raw = {
        ...kept,
        ...(typeof area_sqft === "number" ? { area_band: areaBand(area_sqft) } : {}),
        ...(arrangement ? { arrangement } : {}),
    };
    if (Object.keys(raw).length === 0)
        return undefined;
    const parsed = JobQuantities.safeParse(raw);
    return parsed.success && quantitiesFit(trade, parsed.data) ? parsed.data : undefined;
}
//# sourceMappingURL=quantities.js.map